export default __webpack_public_path__ + "static/media/DinosaurSafari_03.f06cd627.png";